import {appConfig} from '@stencil/hotels-config';
import parseDateIntoHermesString from './date-utils/parse-date-into-hermes-string';

const {defaultPartner} = appConfig;

export default function getSrpUrl({
  checkin,
  checkout,
  roomString,
  destination,
  partner = defaultPartner,
  country = '',
  filter = {},
}) {
  // const {filter = {}, la = '', lo = ''} = srpConfig;
  const {date: checkinDate} = checkin;
  const {date: checkoutDate} = checkout;
  const {n: destinationCityName = '', _id, xtr = {}, ct = {}} = destination;
  let cityName = destinationCityName;
  let cityId = _id;
  const {cc = 'in'} = xtr; // default as india

  if (xtr && xtr.flt) {
    const {n: voyCityName = '', _id: voyCityId = ''} = ct;
    cityName = voyCityName;
    cityId = voyCityId;
  }

  const hotelQueryString = JSON.stringify({
    ci: parseDateIntoHermesString(checkinDate),
    co: parseDateIntoHermesString(checkoutDate),
    r: roomString,
  });

  let nlquery = destination && xtr && xtr.flt ? xtr.flt : null;

  let nQueryString = {};

  let tempfilterObj = {filter: {...filter}};

  const nQuery = {};

  // if (nlquery) {
  //   if (nlquery.pbc) {
  //     nQuery.tags = ['goStays'];
  //   }
  //   if (nlquery.srt) {
  //     nQuery.star = nlquery.srt;
  //   }
  //   if (nlquery.pt) {
  //     nQuery.type = nlquery.pt;
  //   }
  //   if (nlquery.loc) {
  //     nQuery.locations = [];
  //     nQuery.locations.push(encodeURIComponent(nlquery.loc.n.split(',')[0]));
  //   }
  //   if (nlquery.tg) {
  //     nQuery.tag = [nlquery.tg];
  //   }

  //   if (nlquery.sb) {
  //     nQuery.sb = nlquery.sb;
  //   }
  //   tempfilterObj.filter = {...nQuery, ...tempfilterObj.filter};
  // }

  nQueryString =
    '?' +
    JSON.stringify(tempfilterObj)
      .split('/')
      .join('');

  // if (lo && la) {
  //   tempfilterObj.ls = {crd: [la, lo], n};
  //   nQueryString =
  //     '?' +
  //     JSON.stringify(tempfilterObj)
  //       .split('/')
  //       .join('');
  // }

  const ccQ = (country && `&cc=${country}`) || '';

  // const sb = slotSelected ? '&sb=1' : '';
  const sec = cc.toLowerCase() === 'in' ? '&sec=dom' : '&sec=int';
  return `/${partner}/find-hotels-in-${cityName}/${cityId}/${cityId}/${hotelQueryString}/${nQueryString}${sec}${ccQ}`;
  // return `/${partner}/find-hotels-in-${n}/${_id}/${_id}/${hotelQueryString}/${nQueryString}${sec}`;
}
